<template>
  <div>
    <!-- MENSAJE DEL SISTEMA -->
    <mensajeSistema></mensajeSistema>
    <v-container class="mt-8">
      <v-row>
        <v-col cols="12">
          <v-sheet color="grey lighten-4" class="" v-if="readyloadLista">
            <v-skeleton-loader
              class="mx-auto"
              type="table-thead, table-row-divider@3, table-tfoot"
            ></v-skeleton-loader>
          </v-sheet>

          <v-data-table
            v-else
            :headers="cabeceraEstudiante"
            :items="historicoEstudianteConglomeradoDuplicate"
            item-key="id_alumno"
            class="elevation-1 classCustom"
            show-expand
            hide-default-header
            :options.sync="options"
            @update:page="cambiarPagina"
            @update:items-per-page="cambiarCantidadPaginas"
            :server-items-length="totalregistros"
            :footer-props="{
              'items-per-page-options': tamañosPorPagina,
              itemsPerPageText: 'Filas por página',
            }"
          >
            <template
              v-slot:[`item.data-table-expand`]="{ isExpanded, expand }"
            >
              <v-icon
                @mouseenter="hoverIn"
                @mouseleave="hoverOut"
                :class="[
                  'custom-expand-icon',
                  isExpanded
                    ? 'expanded'
                    : 'collapsed animate__animated animate__pulse animate__infinite',
                ]"
                @click="expand(!isExpanded)"
              >
                {{ isExpanded ? "mdi-arrow-up" : "mdi-arrow-down" }}
              </v-icon>
            </template>
            <template v-slot:header>
              <thead class="v-data-table-header">
                <tr>
                  <th
                    v-for="header in cabeceraEstudiante"
                    :key="header.value"
                    :colspan="header.text == 'Alumno' ? 2 : 0"
                    :class="header.class"
                  >
                    <span> {{ header.text }} </span>
                  </th>
                </tr>
              </thead>
            </template>

            <template v-slot:[`item.desc_nivel`]="{ item }">
              <v-chip dark :color="item.color" class="ml-0 mr-2" label small>
                {{ item.desc_nivel }}
              </v-chip>
            </template>

            <template v-slot:expanded-item="{ item, headers }">
              <td class="pa-0" :colspan="headers.length">
                <v-data-table
                  :headers="areaHeaders"
                  :items="item.areas_estudiante"
                  item-key="id_area_adm"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  class="elevation-1"
                  dense
                >
                  <template v-slot:header>
                    <thead class="v-data-table-header">
                      <tr>
                        <th
                          v-for="header in areaHeaders"
                          :key="header.value"
                          :colspan="2"
                          :class="header.class"
                        >
                          <span> {{ header.text }} </span>
                        </th>
                      </tr>
                    </thead>
                  </template>

                  <template v-slot:item="{ item: area }">
                    <tr>
                      <td>{{ area.desc_area }}</td>
                      <!-- <td>{{ area.nivel_logro_anual }}</td> -->
                      <td class="pa-0">
                        <v-data-table
                          :headers="competenciasHeaders"
                          :items="area.nivel_logro_competencias_area"
                          item-key="ID_COMPETENCIA"
                          hide-default-footer
                          disable-pagination
                          class="elevation-1"
                          dense
                        >
                          <template v-slot:item="{ item: competencia }">
                            <tr>
                              <td>{{ competencia.DESCRIPCION_COMPETENCIA }}</td>
                              <td>
                                <b
                                  :style="
                                    obtenerEstilosParaNotas(
                                      obtenerNotaComp(
                                        competencia.NIVEL_LOGRO_COMPETENCIA
                                      )
                                    )
                                  "
                                >
                                  {{
                                    convertirNumAliteral(
                                      obtenerNotaComp(
                                        competencia.NIVEL_LOGRO_COMPETENCIA
                                      )
                                    )
                                  }}
                                </b>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
// eslint-disable-next-line no-unused-vars
import { mapMutations } from "vuex";

export default {
  name: "HistorialConglomerado",
  components: {},
  props: {
    estado: {
      type: Boolean,
    },
    parametros: {
      type: Object,
    },
    searchProp: {
      type: String,
    },
  },
  data: () => ({
    readyloadLista: false,
    loadingPage: false,
    options: {
      itemsPerPage: 10,
    },
    datoLogin: sessionStorage,
    cabeceraEstudiante: [
      {
        text: "Alumno",
        value: "nombres_completos",
        class: "secondary black-text text-start",
      },
      {
        text: "Nivel",
        value: "desc_nivel",
        class: "secondary black-text text-start",
      },
      {
        text: "Grado",
        value: "desc_grado",
        class: "secondary black-text text-start",
      },
    ],
    areaHeaders: [
      {
        text: "Área",
        value: "desc_area",
        class: "blue lighten-4 black-text text-start",
      },
    ],
    competenciasHeaders: [
      {
        text: "Competencia",
        value: "DESCRIPCION_COMPETENCIA",
        class: "amber lighten-4 text-start w-70",
      },
      {
        text: "Nivel de Logro",
        value: "NIVEL_LOGRO_COMPETENCIA",
        class: "amber lighten-4 text-start w-30",
      },
    ],
    historicoEstudianteConglomerado: [],
    historicoEstudianteConglomeradoDuplicate: [],

    paginaActual: 1,
    totalPaginas: 0,
    tamanioPorPagina: 6,
    tamañosPorPagina: [5, 10, 20],
    totalregistros: 0,
    orden: "id_alumno",
    orderByMode: "ASC",
  }),
  mounted() {
    this.loadMain();
  },
  watch: {
    parametros: {
      deep: true,
      handler: function () {
        this.historialConglomerado(false);
      },
    },
    searchProp() {
      this.historialConglomerado(true);
    },
  },
  methods: {
    /*______________________
    │   * Método inicio     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    loadMain() {
      this.historialConglomerado(false);
    },
    /*___________________________________________
    │   * Método para agrupar datos de tabla     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    toggleGroup(group) {
      const index = this.expanded.indexOf(group);
      if (index > -1) {
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(group);
      }
    },
    /*___________________________________________
    │   * Método obtener el nombre de alumno     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    getAlumnoNombre(id_alumno) {
      const alumno = this.historicoEstudianteConglomerado.find(
        (alumno) => alumno.id_alumno === id_alumno
      );
      return alumno ? alumno.nombres_completos : "Desconocido";
    },
    /*_____________________________________________________
    │   * Método para intercambiar clases de animación     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    hoverIn(e) {
      e.target.classList.remove("animate__pulse");
      e.target.classList.add("animate__heartBeat");
    },
    /*_____________________________________________________
    │   * Método para intercambiar clases de animación     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    hoverOut(e) {
      e.target.classList.remove("animate__heartBeat");
      e.target.classList.add("animate__pulse");
    },
    /*_______________________________________
    │   * Método cambiar pagina dinamico     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    cambiarPagina(numeroPagina) {
      this.paginaActual = numeroPagina;
      this.historialConglomerado(true);
    },
    /*___________________________________________________
    │   * Método para cambiar el tamaño de la pagina     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    cambiarCantidadPaginas(tamaño) {
      this.tamanioPorPagina = tamaño;
      this.paginaActual = 1;
      this.historialConglomerado(true);
    },
    /*__________________________________________
    │   * Método para obtener la paginacion     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async obtenerParametros(
      valorBusqueda,
      paginaActual,
      tamanioPorPagina,
      orden,
      orderByMode,
      parametrosProps,
      id_colegio
    ) {
      const { id_ano_lectivo, id_nivel_ck1, id_grado_ck1 } = parametrosProps;
      const parametros = {};

      if (valorBusqueda) {
        parametros.valor = valorBusqueda;
      }
      if (paginaActual) {
        parametros.paginaActual = paginaActual - 1;
      }
      if (tamanioPorPagina) {
        parametros.tamanioPorPagina = tamanioPorPagina;
      }
      if (orden) {
        parametros.orden = orden;
      }
      if (orderByMode) {
        parametros.orderByMode = orderByMode;
      }
      if (id_ano_lectivo) {
        parametros.id_ano_lectivo = id_ano_lectivo;
      }
      if (id_nivel_ck1) {
        parametros.id_nivel_clickone = id_nivel_ck1;
      }
      if (id_grado_ck1) {
        parametros.id_grado_clickone = id_grado_ck1;
      }
      if (id_colegio) {
        parametros.id_colegio = id_colegio;
      }
      return parametros;
    },
    /*_____________________________________________________
    │   * Método para listar historial de conglomerado     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async historialConglomerado(paginacion) {
      this.readyloadLista = !paginacion ? true : false;
      this.loadingPage = paginacion ? true : false;

      const patrametosPaginacion = await this.obtenerParametros(
        this.searchProp,
        this.paginaActual,
        this.tamanioPorPagina,
        this.orden,
        this.orderByMode,
        this.parametros,
        Number(this.datoLogin.id_colegio)
      );

      try {
        // const response = respuesta;
        const { data } = await axios.get(
          `/cierreanio/cierreanioituacionestudiante/listarHistorialConglomerado`,
          {
            params: patrametosPaginacion,
          }
        );

        // eslint-disable-next-line no-unused-vars
        const { totalFilas, filas, totalPaginas, paginaActual } = data;

        this.historicoEstudianteConglomerado = filas;
        this.historicoEstudianteConglomeradoDuplicate = filas;
        this.totalPaginas = totalPaginas;
        this.totalregistros = Number(totalFilas);

        this.readyloadLista = false;
        this.loadingPage = false;
      } catch (error) {
        console.error(error);
      }
    },
    /*_____________________________________________________________________
    │   * Método para obtener los estilos deacuerdo a la nota obtenido     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerEstilosParaNotas(notaNum) {
      switch (notaNum) {
        case 4:
          return "color:#4caf50;";
        case 3:
          return "color:#4caf50;";
        case 2:
          return "color:#ffbc00;";
        case 1:
          return "color:#e53935;";
        default:
          return "";
      }
    },
    /*___________________________________________________________
    │   * Método para convertir nota numerica a nota literal     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    convertirNumAliteral(notaNum) {
      switch (notaNum) {
        case 4:
          return "AD";
        case 3:
          return "A";
        case 2:
          return "B";
        case 1:
          return "C";
        default:
          return "";
      }
    },
    /*________________________________________________________________
    │   * Método para obtener el valor o nota de las competencias     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerNotaComp(nota) {
      return Math.round(nota);
    },
  },
};
</script>
<style scoped>
.custom-expand-icon.collapsed {
  cursor: pointer;
  color: #31c92b; /* Color del ícono cuando está colapsado */
  transition: color 0.3s ease;
}

.custom-expand-icon.expanded {
  color: #e91e63; /* Color del ícono cuando está expandido */
}
</style>